<template>
<div class="list-float-header">
  <div class="float-left w220">

  </div>

  <div class="date-time float-left">
    <div class="w220">
      <label>{{$t('INDENT_REPORTED_AT')}}</label>
    </div>
  </div>

  <div class="date-time float-left">
    <div class="w220">
      <label>{{$t('INDENT_POD_DATE')}}</label>
    </div>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
};
</script>
